import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 9.99953C6 9.74367 6.10681 9.48768 6.32043 9.29269L12.8829 3.29296C13.3102 2.90235 14.0023 2.90235 14.4296 3.29296C14.8568 3.68356 14.8568 4.31635 14.4296 4.70696L8.63867 9.99953L14.4287 15.293C14.856 15.6837 14.856 16.3164 14.4287 16.707C14.0015 17.0977 13.3093 17.0977 12.8821 16.707L6.31958 10.7073C6.10596 10.512 6 10.2558 6 9.99953Z",
		fill: "#0D2976"
	})
});
export default SvgChevronLeft;
